<template>
  <div class="page-wrapper">
    <v-col cols="12" lg="10" md="7">
      <v-form>
        <v-card class="card-shadow bg-secondary">
          <ListaPremio />
        </v-card>
      </v-form>
    </v-col>
  </div>
</template>


<script>
import ListaPremio from "../Components/Listagens/ListaPremio.vue";
export default {
  name: "ListPromoter",
  components: {
    ListaPremio,
  },
  data() {
    return {};
  },
};
</script>
<style scoped>
.page-wrapper {
  display: flex;
  justify-content: center;
}
</style>
